import { Note } from "../note/Note"
import { PurchaseOrder } from "../purchase_order/PurchaseOrder"
import { PurchaseOrderAllocationOptionDetails } from "../purchase_order/PurchaseOrderAllocationOptionDetails"

export class OrderPartDetails {
  id: number
  displayOrder: number
  inventoryItemId: number
  name: string
  notes: Note[]
  price: number
  purchaseOrder?: PurchaseOrder
  purchaseOrderAllocationOptions: PurchaseOrderAllocationOptionDetails[]
  showAllocateFromPurchaseOrder: boolean
  showCreatePurchaseOrderForAllItems: boolean
  showCreatePurchaseOrderForSingleItem: boolean
  showPullFromInventory: boolean
  status: number
  totalQuantityOnHand: number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, displayOrder: number, inventoryItemId: number, name: string, notes: any, price: number, purchaseOrder: any, purchaseOrderAllocationOptions: any, showAllocateFromPurchaseOrder: boolean, showCreatePurchaseOrderForAllItems: boolean, showCreatePurchaseOrderForSingleItem: boolean, showPullFromInventory: boolean, status: number, totalQuantityOnHand: number) {
    this.id = id
    this.displayOrder = displayOrder
    this.inventoryItemId = inventoryItemId
    this.name = name
    this.price = price
    this.purchaseOrder = purchaseOrder ? purchaseOrder as PurchaseOrder : undefined
    this.purchaseOrderAllocationOptions = purchaseOrderAllocationOptions as PurchaseOrderAllocationOptionDetails[]
    this.showAllocateFromPurchaseOrder = showAllocateFromPurchaseOrder
    this.showCreatePurchaseOrderForAllItems = showCreatePurchaseOrderForAllItems
    this.showCreatePurchaseOrderForSingleItem = showCreatePurchaseOrderForSingleItem
    this.showPullFromInventory = showPullFromInventory
    this.status = status
    this.totalQuantityOnHand = totalQuantityOnHand
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notes ? notes.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []    
  }
}